(function () {
  'use strict';

  // ── Bot detection ──
  if (/bot|crawl|spider|slurp|googlebot|bingbot|yandex|baidu|duckduck|facebookexternalhit|linkedinbot|twitterbot|applebot|semrush|ahrefs|mj12bot|dotbot|petalbot/i.test(navigator.userAgent)) return;

  // ── Store configuration ──
  var STORAGE_KEY = 'broasters_store_choice';

  var STORES = {
    ch: {
      matchDomains: ['broasters.ch'],
      targetCountries: ['FR'],
      targetKey: 'fr',
      flagFrom: 'ch',
      flagTo: 'fr',
      eyebrow: 'Livraison en France',
      title: 'Vous nous rendez visite<br>depuis la France',
      desc: 'Vous \u00eates sur notre boutique suisse (prix en CHF). Retrouvez nos caf\u00e9s torr\u00e9fi\u00e9s artisanalement, livr\u00e9s en France et affich\u00e9s en euros.',
      ctaPrimary: 'Aller sur la boutique France',
      ctaSecondary: 'Rester sur la boutique Suisse \u00b7 CHF',
      targetUrl: 'https://broasterscoffee.fr/'
    },
    fr: {
      matchDomains: ['broasterscoffee.fr'],
      targetCountries: ['CH', 'LI'],
      targetKey: 'ch',
      flagFrom: 'fr',
      flagTo: 'ch',
      eyebrow: 'Livraison en Suisse',
      title: 'Vous nous rendez visite<br>depuis la Suisse',
      desc: 'Vous \u00eates sur notre boutique fran\u00e7aise (prix en \u20ac). Retrouvez nos caf\u00e9s torr\u00e9fi\u00e9s artisanalement, livr\u00e9s en Suisse et affich\u00e9s en francs.',
      ctaPrimary: 'Aller sur la boutique Suisse',
      ctaSecondary: 'Rester sur la boutique France \u00b7 EUR',
      targetUrl: 'https://broasters.ch/'
    }
  };

  // ── Determine current store ──
  var el = document.getElementById('store-switcher');
  if (!el) return;

  var domain = el.getAttribute('data-store-domain') || window.location.hostname;
  var store = null;
  var storeKey = null;

  for (var key in STORES) {
    for (var i = 0; i < STORES[key].matchDomains.length; i++) {
      if (domain.indexOf(STORES[key].matchDomains[i]) !== -1) {
        store = STORES[key];
        storeKey = key;
        break;
      }
    }
    if (store) break;
  }

  if (!store) return;

  // ── Stored choice ──
  function getChoice() {
    try { return localStorage.getItem(STORAGE_KEY); } catch (e) { /* private browsing */ }
    var m = document.cookie.match(new RegExp('(?:^|; )' + STORAGE_KEY + '=([^;]+)'));
    return m ? m[1] : null;
  }

  function saveChoice(val) {
    try { localStorage.setItem(STORAGE_KEY, val); } catch (e) { /* private browsing */ }
    var d = new Date();
    d.setTime(d.getTime() + 30 * 864e5);
    document.cookie = STORAGE_KEY + '=' + val + ';expires=' + d.toUTCString() + ';path=/;SameSite=Lax';
  }

  if (getChoice()) return;

  // ── Country detection ──
  function detect() {
    // Shopify geo-detection endpoint (visitor country from IP)
    return fetch('/browsing_context_suggestions.json')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && data.detected_values && data.detected_values.country) {
          return data.detected_values.country.handle;
        }
        return langFallback();
      })
      .catch(function () {
        return langFallback();
      });
  }

  function langFallback() {
    var lang = (navigator.language || '').toLowerCase();
    if (/^(fr|de|it|rm)-ch$/i.test(lang)) return 'CH';
    if (/^fr(-fr)?$/i.test(lang)) return 'FR';
    return null;
  }

  // ── Show popup ──
  function show(country) {
    if (!country || store.targetCountries.indexOf(country) === -1) return;

    // Arrange flags: current store flag first → target store flag
    var flags = el.querySelector('.ss-flags');
    var flagFrom = flags.querySelector('.ss-flag--' + store.flagFrom);
    var arrow = flags.querySelector('.ss-arrow');
    var flagTo = flags.querySelector('.ss-flag--' + store.flagTo);
    flags.textContent = '';
    flags.appendChild(flagFrom);
    flags.appendChild(arrow);
    flags.appendChild(flagTo);

    // Fill text content
    el.querySelector('.ss-eyebrow').textContent = store.eyebrow;
    el.querySelector('.ss-title').innerHTML = store.title;
    el.querySelector('.ss-desc').textContent = store.desc;

    var cta = el.querySelector('.ss-cta-primary');
    cta.textContent = store.ctaPrimary;
    cta.href = store.targetUrl;

    el.querySelector('.ss-cta-secondary').textContent = store.ctaSecondary;

    // Reveal
    el.style.display = '';
    el.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';

    // ── Event handlers ──
    function close() {
      saveChoice(storeKey);
      el.style.display = 'none';
      el.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    el.querySelector('.ss-close').addEventListener('click', close);
    el.querySelector('.ss-cta-secondary').addEventListener('click', close);
    el.querySelector('.ss-overlay').addEventListener('click', close);

    cta.addEventListener('click', function (e) {
      e.preventDefault();
      saveChoice(store.targetKey);
      window.location.href = store.targetUrl;
    });

    document.addEventListener('keydown', function onEsc(e) {
      if (e.key === 'Escape') {
        close();
        document.removeEventListener('keydown', onEsc);
      }
    });
  }

  // ── Run ──
  detect().then(show);
})();